<div class="container" *ngIf="!isLoginModal">
    <button type="button" class="btn btn-primary login_button" (click)='onModal()'>
        Login
    </button>
</div>

<div *ngIf="isLoginModal" class="modal fade" id="loginModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h5 class="modal-title title" id="exampleModalLongTitle">
                    Login
                </h5>
                <button type="button" class="btn btn-primary close" (click)="_onClose()">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <div class="mt-3">
                                <div class="google">
                                </div>
                                <div class="facebook">
                                    <p><button class="btn btn-primary button fb_bt" type="button">
                                            <img src="/assets/images/facebook.png" />Continue with Facebook
                                        </button></p>
                                </div>
                            </div>

                            <div class="row form-row social-login mt-3">                  
                                <div class="col-6">
                                    <div id="g_id_onload" class="w-100" [attr.data-client_id]="GOOGLE_CLIENT_ID"
                                        data-context="signin" data-ux_mode="popup" [attr.data-login_uri]="REDIRECT_URL"
                                        data-auto_select="true" data-itp_support="true">
                                    </div>

                                    <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="outline"
                                        data-text="continue_with" data-size="large" data-logo_alignment="left">
                                    </div>

                                </div>
                            </div>

                            <div class="or mt-1">OR</div>
                            <form *ngIf="!is_show_otp" action="" [formGroup]="loginForm" method="POST">
                                <div class="email form-group error-msg mb-1"
                                    *ngIf="isSubmitError || (loginForm.get('email')!.invalid && this.submit==true)">
                                    <p style="color: red;">Invalid Credentials</p>
                                </div>
                                <div class="email form-group">
                                    <p><input type="email" class="form-control" placeholder="Email"
                                            formControlName="email"></p>
                                </div>
                                <div class="or">OR</div>
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon1">+971</span>
                                    <input type="text" class="form-control" name="phone" id="phone"
                                        placeholder=" Phone Number" formControlName="phone" maxlength="9">
                                </div>
                                <div class="email form-group">
                                    <p><input type="password" class="form-control" placeholder="Password" id="password"
                                            formControlName="password"></p>
                                </div>

                                <div class="text-end">
                                <a href="/forgot-password" class="text-dark ">Forgot Password?</a>
                            </div>
                                <div class="continue">
                                    <p><input class="btn btn-primary button" type="button" name="" value="Login"
                                            (click)="onlogin_details()"></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>